module.exports = __webpack_public_path__ + "img/pdf-header.887a12cb.png";